(<strong>{{ review.by }} - {{ review.source }}) </strong>
{{ preview }}
@if (more && !showMore) {
  ...
  <a mat-button tabindex="0" (click)="showMore = true" (keyup.enter)="showMore = true"
    >(read more)</a
  >
}
@if (showMore) {
  {{ more }}
}
